/* eslint-disable no-undef */
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import React from 'react';
import driverIcon from '../../assets/img/map-icons/driver.svg';
import restaurantIcon from '../../assets/img/map-icons/restaurant.svg';
import userIcon from '../../assets/img/map-icons/user.svg';
import app from '../../http/firebase';
import { mapStyles } from '../../utils/constants';
import { getRestaurants, getOrders, assign, eraseAssignError } from "../../store/actions";
import { connect } from "react-redux";

const { compose, withProps, lifecycle, withStateHandlers } = require("recompose");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");



const InfoBoxValue = props => (
    <div style={{padding: '7px 2px', fontSize: '12px'}}>ID: { props.id }</div>
);

const Map = compose(
    withProps({
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `calc(100vh - 70px)` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withStateHandlers(() => ({
        isOpen: false,
        currentDriverId: ''
    }), {
        onToggleOpen: ({ isOpen }) => (nearlyDriver) => {
            if(nearlyDriver){
                return ({
                    isOpen: true,
                    currentDriverId: nearlyDriver.id
                });
            }

        }
    }),
    withGoogleMap,
    lifecycle({
        componentDidMount() {
            let centerPosition = {
                lat: this.props.position ? +this.props.position.latitude : 24.774265,
                lng: this.props.position ? +this.props.position.longitude : 46.738586
            };
            if(this.props.alert){
                centerPosition = {
                    lat: this.props.position.latitude,
                    lng: this.props.position.longitude
                };
            }
            this.setState({ centerPosition });
            setTimeout(() => {
                this.setState({ centerPosition })
            }, 0);
            this.props.getRestaurants();
            this.props.getOrders();
            const database = app.database().ref().child('dev').child('drivers');
            database.on('value', rp => {
                const drivers = rp.val();
                if(drivers) {
                    const keys = Object.keys(drivers);
                    const transformedDrivers = keys.map(key => {
                        return {
                            id: key,
                            lat: drivers[key].lat,
                            lng: drivers[key].lng
                        };
                    });
                    this.setState({ drivers: transformedDrivers });
                }

            });
        },
        componentWillUnmount() {
            // this.state.database.unsubscribe();
        }
    })
)(props => {
    // const centerPosition = { lat: props.position ? props.position.latitude : 24.774265, lng: props.position ? props.position.longitude : 46.738586 };
    let driverMarkers = null;
    let restaurantMarkers = null;
    let userMarkers = null;
    let markers = [];
    // /orders/assign-driver-by-admin/ POST {"order": 0, "driver": 0 }
        driverMarkers = props.drivers ? props.drivers.map(driver => {
            const nearlyDriver = props.freeDrivers && props.freeDrivers.find(freeDriver => +freeDriver.id === +driver.id);
            if(props.freeDrivers && !nearlyDriver){
                return null;
            }
            if(driver.id < 0) {
                return null;
            }

            return (
                <Marker onClick={() => {props.onToggleOpen(nearlyDriver); props.eraseAssignError();} } key={driver.id} icon={{url: driverIcon, scaledSize: new google.maps.Size(30, 30) }} position={{lat: driver.lat, lng: driver.lng}}>
                    <InfoBox  options={{disableAutoPan: true, boxStyle: { width: '82px', overflow: 'hidden' }, pixelOffset: new google.maps.Size(-40,-32),alignBottom: true, closeBoxURL: ``, enableEventPropagation: true }}>
                        <InfoBoxValue id={ driver.id }/>
                    </InfoBox>
                    {props.freeDrivers && props.isOpen && +props.currentDriverId === +driver.id && <InfoBox defaultOptions={ { boxClass: 'assign', enableEventPropagation: true, disableAutoPan: true } }  onCloseClick={props.onToggleOpen}>
                        {props.assignError ? <div className="assign-cancel">
                            <ul className="w-700">
                                <li className="mb-20">
                                    <p className="color-primary font-sm">
                                        Sorry, the time has passed and the order is canceled.
                                    </p>
                                </li>
                            </ul>
                            <button onClick={ props.changeAlertStatus } type="button" className="btn small filled primary min-120">
                                Go Back
                            </button>
                        </div> : <div className="assign-box">
                            <ul className="stars small">
                                { !nearlyDriver.rate && props.renderRateStars(nearlyDriver.rate)}
                            </ul>
                            <ul className="w-700">
                                <li className="mb-15">
                                    <p className="font-xs color-grey50 pb-5">Driver Name</p>
                                    <p className="color-primary font-sm">{ nearlyDriver.first_name_en }</p>
                                </li>
                                <li className="mb-20">
                                    <p className="font-xs color-grey50">Driver ID</p>
                                    <p className="color-primary font-sm">{nearlyDriver.id}</p>
                                </li>
                            </ul>
                            <button onClick={ () => { props.assign(props.alertId, {order: props.order, driver: nearlyDriver.id}).then(res => { res==='done' ?  props.history.push('/operation-room/map'): null }) } }
                                    type="button"
                                    className="btn small filled primary min-120">
                                Assign
                            </button>
                        </div> }
                    </InfoBox>}
                </Marker>
            );
        }): [];
        restaurantMarkers = props.restaurants ? props.restaurants.map(restaurant => {
            return (
                <Marker key={restaurant.id + restaurant.address} icon={{url: restaurantIcon, scaledSize: new google.maps.Size(30, 30) }} position={{lat: restaurant.position.latitude, lng: restaurant.position.longitude}} >
                        <InfoBox options={{disableAutoPan: true, boxStyle: { width: '82px', overflow: 'hidden' }, pixelOffset: new google.maps.Size(-40,-32),alignBottom: true, closeBoxURL: ``, enableEventPropagation: true }}>
                            <InfoBoxValue id={ restaurant.id }/>
                        </InfoBox>
                </Marker>
            );
        }): [];
        userMarkers = props.orders ? props.orders.map(order => {
            return (
                <Marker key={order.id + order.user + order.requester_phone_number} icon={{url: userIcon, scaledSize: new google.maps.Size(30, 30) }} position={{lat: order.user_position.latitude, lng: order.user_position.longitude}}>
                    <InfoBox options={{disableAutoPan: true, boxStyle: { width: '82px', overflow: 'hidden' }, pixelOffset: new google.maps.Size(-40,-32), alignBottom: true, closeBoxURL: ``, enableEventPropagation: true }}>
                        <InfoBoxValue id={ order.user }/>
                    </InfoBox>
                </Marker>
            );
        }): [];
        markers = [ ...driverMarkers, ...restaurantMarkers, ...userMarkers];
        const centerPosition = props.centerPosition ? {...props.centerPosition}: {lat: 24.774265, lng: 46.738586};
    return  (
    props.centerPosition ? <GoogleMap defaultCenter={ centerPosition } defaultOptions={{ styles: mapStyles }} defaultZoom={14}>
            { markers }
        </GoogleMap> : null
    );
});

const mapStateToProps = state => {
    return {
        restaurants: state.operations.restaurants,
        orders: state.operations.orders,
        assignError: state.customer.assignError
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getRestaurants: () => dispatch( getRestaurants() ),
        getOrders: () => dispatch( getOrders(1, null, 'for map') ),
        assign: (alertId, data) => dispatch( assign(alertId, data) ),
        eraseAssignError: () => dispatch( eraseAssignError() )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)( Map );





// WEBPACK FOOTER //
// ./src/components/Map/Map.js